import React from 'react';
import { styles } from '../../styles/theme';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.body}>
          <div style={styles.container}>
            <div style={{
              ...styles.card,
              maxWidth: '600px',
              margin: '100px auto',
              textAlign: 'center'
            }}>
              <h1 style={{
                color: '#da3633',
                fontSize: '48px',
                marginBottom: '16px'
              }}>
                Oops!
              </h1>
              <h2 style={{
                color: '#f0f6fc',
                fontSize: '20px',
                marginBottom: '16px'
              }}>
                Algo deu errado
              </h2>
              <p style={{
                color: '#7d8590',
                marginBottom: '24px'
              }}>
                Ocorreu um erro inesperado. Por favor, tente novamente ou recarregue a pagina.
              </p>
              {this.state.error && process.env.NODE_ENV === 'development' && (
                <details style={{
                  textAlign: 'left',
                  marginBottom: '24px',
                  padding: '16px',
                  backgroundColor: '#0d1117',
                  borderRadius: '6px',
                  border: '1px solid #30363d'
                }}>
                  <summary style={{
                    cursor: 'pointer',
                    color: '#58a6ff',
                    marginBottom: '8px'
                  }}>
                    Detalhes do erro (apenas desenvolvimento)
                  </summary>
                  <pre style={{
                    color: '#da3633',
                    fontSize: '12px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word'
                  }}>
                    {this.state.error.toString()}
                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                  </pre>
                </details>
              )}
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                <button
                  style={styles.button}
                  onClick={this.handleRetry}
                >
                  Tentar Novamente
                </button>
                <button
                  style={{ ...styles.button, ...styles.buttonSecondary }}
                  onClick={() => window.location.reload()}
                >
                  Recarregar Pagina
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
